/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:50:13
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Card from '@/components/Common/Card';
import HelpFaqItem from '@/components/Help/HelpFaq/HelpFaqItem';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'HelpFaq',

  components: { HelpFaqItem, Card },

  props: ['faqList'],
};



// WEBPACK FOOTER //
// ./src/components/Help/HelpFaq/component.js